import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { DELTALAKE } from "../../Constants"

function ZdqDeltaLakeConnectorStatus() {
    return <ZdqConnectorStatus vendor={DELTALAKE}></ZdqConnectorStatus>
}

export default ZdqDeltaLakeConnectorStatus